
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemaps/sitemap-wiki.xml",
      function () {
        return require("private-next-pages/sitemaps/sitemap-wiki.xml.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemaps/sitemap-wiki.xml"])
      });
    }
  